import { render, staticRenderFns } from "./GlobeAltSolid.vue?vue&type=template&id=8adbc7fe&"
import script from "./GlobeAltSolid.vue?vue&type=script&lang=ts&"
export * from "./GlobeAltSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports